module.exports = __webpack_public_path__ + "img/right-answer-illustration.b87fd6c2.png";